
import { IMRDXDashboardSimpleController } from "./dxdashboard-simple.controller"
import { DXDASHBOARD_SERVICE_NAME } from "../../services"

import './dxdashboard-simple.scss'
import * as TEMPLATE from './dxdashboard-simple.tpl.html'

export const COMPONENT_NAME: string = 'imrDxdashboardSimple'

export class IMRDXDashboardSimpleComponent implements ng.IComponentOptions {

    controller = [DXDASHBOARD_SERVICE_NAME, IMRDXDashboardSimpleController]

    bindings = {
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE

}
